import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import { debounce } from 'underscore';

import style from './styles';

import {
  overlap,
  optimizedEvent,
  isFixed,
  getElementData,
} from './utils';

import NavigationListItem from '../NavigationListItem';

class Navigation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlap: false,
      scrolling: false,
      fixed: false,
    };
  }

  componentDidMount() {
    const nav = document.getElementById('nav');
    const targets = document.getElementsByClassName('media');
    const bottomMarker = document.getElementById('end-of-scrolling');


    this.onScroll = optimizedEvent('scroll');

    window.setTimeout(() => {
      const navData = getElementData(nav);
      const bottomData = getElementData(bottomMarker);

      this.onScroll.add(() => isFixed(navData, bottomData, this.setFixed));
    }, 1);

    this.o = overlap(nav, targets);
    this.onScroll.add(this.scrollEvent);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.scrolling && prevState.scrolling !== this.state.scrolling) {
      this.setOverlap();
    }
  }

  componentWillUnmount() {
    this.onScroll.remove();
  }

  setOverlap = debounce(() => {
    this.setState(() => ({
      overlap: !!this.o.overlap(),
      scrolling: false,
    }));
  }, 900);

  setFixed = (bool) => {
    if (bool !== this.state.fixed) {
      this.setState(() => ({ fixed: bool }));
    }
  }

  scrollEvent = () => {
    this.setState(() => ({ scrolling: true }));
  }

  render() {
    const { Content } = this.props;
    const shouldShowNav = !this.state.overlap || this.state.scrolling;

    return (
      <div
        className={ css(style.navContainer) }
        id="nav"
        onMouseOver={() => this.setState({overlap: false})}
        onMouseLeave={() => this.setOverlap()}
        style={{
          opacity: shouldShowNav ? 1 : 0,
          position: this.state.fixed ? 'fixed' : 'absolute',
          top: this.state.fixed ? '50%' : 132,
          transform: this.state.fixed ? 'translateY(-176px)' : 'translateY(0)',
        }}
      >
        <ul className={ css(style.ul) }>
          { Content.map(({ id, section, linkText }) => (
            <NavigationListItem
              key={ id }
              section={ section }
              linkText={linkText}
            />
          )) }
        </ul>
      </div>
    );
  }
}

Navigation.propTypes = {
  Content: React.PropTypes.array.isRequired,
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation/index.js